import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isSolved: false
  },
  mutations: {
    SET_IS_SOLVED: (state, val) => {
      state.isSolved = val
    }
  },
  actions: {
    setSolved: ({ commit }, val) => {
      commit("SET_IS_SOLVED", val)
    },
  },
  getters: {
    isSolved: state => {
      return state.isSolved
    }
  },
  modules: {
  }
})
